'use strict';
angular.module('sysMediaTagSortModule', [])
    .controller('sysMediaTagSortCtrl', ['$scope', '$modalInstance', '$validation', 'mediaTagApiService', 'modalDialog', 'options', function($scope, $modalInstance, $validation, mediaTagApiService, modalDialog, options) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.sortIndex = getSortIndex();
            $scope.data = {
                id: options.id, 
                index: $scope.sortIndex,
                type: options.type,
            };
            $scope.params = {
                id: options.id, 
                index: $scope.sortIndex,
                type: options.type,
            },
            $scope.status = {
                total: options.total
            };
        }

        /**
         * [获取新的排序值]
         */
        function getNewOrderNum() {
            let orderNum = options.orderNum;
            let curIndex = parseInt($scope.data.index) - 1;
            angular.forEach(options.datas, function(item, index){
                if (curIndex === index) {
                    orderNum = item.ordernum - 1;
                }
            });
            return orderNum;
        }

        /**
         * [getSortIndex 获取标签在当前列表中的排序]
         *
         * @param   {[type]}  curItem  [curItem description]
         *
         * @return  {[type]}           [return description]
         */
        function getSortIndex() {
            let sortIndex = 0;
            angular.forEach(options.datas, function(item, index){
                if (item.id === options.id) {
                    sortIndex = index;
                }
            });
            sortIndex++;
            return sortIndex;
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            if ($scope.data.index > options.datas.length) {
                modalDialog.alertType('', '输入的顺序不能大于当前列表最大序号', 'error', false);
                return;
            }
            $scope.sortForm.$pending = {};
            $scope.params.index = $scope.data.index;
            $validation.validate($scope.sortForm).success(function() {
                $scope.loadingPromise = mediaTagApiService.reSortTag($scope.params).then(function(data) {
                    if (data.code === '200') {
                        modalDialog.alertType('', '调整顺序成功', 'success', false);
                        $modalInstance.close('success');
                    } else {
                        modalDialog.alertType('', data.msg, 'error', false);
                    }
                });
            });
        };
    }]);
